export default __webpack_public_path__ + "static/media/user-logout-red.3f05c39a.svg";